function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../../contexts';
import { getFunnelSteps, getQuery } from '../../../../modules/query';
import Property from '../../../Property';
import PropertyGroup, { PropertyItem } from '../../../PropertyGroup';
import { getValueComponent } from './getValueComponent';

var FilterValue = function FilterValue(_ref) {
  var propertyType = _ref.propertyType,
      operator = _ref.operator,
      value = _ref.value,
      onChange = _ref.onChange,
      id = _ref.id,
      propertyName = _ref.propertyName,
      funnelStepId = _ref.funnelStepId;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var stringPlaceholder = t('query_creator_filter_value.input_text_placeholder');
  var query = useSelector(getQuery);

  var _useContext = useContext(AppContext),
      disableFilterSuggestions = _useContext.disableFilterSuggestions;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      suggestionsLoading = _useState4[0],
      setSuggestionsLoading = _useState4[1];

  var _useState5 = useState(!disableFilterSuggestions),
      _useState6 = _slicedToArray(_useState5, 2),
      suggestionsVisible = _useState6[0],
      setSuggestionsVisible = _useState6[1];

  var _useContext2 = useContext(AppContext),
      keenClient = _useContext2.keenClient;

  var steps = useSelector(getFunnelSteps);

  if (funnelStepId && steps.length > 0) {
    query = steps.find(function (step) {
      return step.id === funnelStepId;
    });
  }

  useEffect(function () {
    if (propertyName && !disableFilterSuggestions) {
      var uniqueValuesQuery = {
        analysis_type: 'select_unique',
        event_collection: query.eventCollection,
        target_property: propertyName,
        timezone: query.timezone,
        timeframe: query.timeframe
      };
      setSuggestionsLoading(true);
      keenClient.query(uniqueValuesQuery).then(function (response) {
        var _a;

        return setSuggestions((_a = response.result) === null || _a === void 0 ? void 0 : _a.map(String));
      }).finally(function () {
        setSuggestionsLoading(false);
      });
    }
  }, [propertyName, query.timezone, query.timeframe]);
  useEffect(function () {
    setSuggestionsVisible(['contains', 'not_contains', 'eq', 'ne', 'in'].includes(operator) && propertyType === 'String' && !disableFilterSuggestions);
  }, [operator]);
  return React.createElement(React.Fragment, null, propertyType && operator ? React.createElement(React.Fragment, null, getValueComponent({
    propertyType: propertyType,
    operator: operator,
    onChange: onChange,
    value: value,
    id: id,
    stringPlaceholder: stringPlaceholder,
    suggestions: suggestions,
    suggestionsLoading: suggestionsLoading,
    suggestionsVisible: suggestionsVisible
  })) : React.createElement(PropertyGroup, {
    isActive: false
  }, React.createElement(PropertyItem, null, React.createElement(Property, {
    placeholder: t('query_creator_filter_value.placeholder')
  }))));
};

export default FilterValue;